import React, { useState, useCallback, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { FAQ } from "helpers/viewContent";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import * as Yup from "yup";
import { addFAQ_, updateFAQ_, viewFAQ_ } from "store/services/faqService";
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";

const editorConfiguration = {
  toolbar: [
    "heading",
    "|",
    "bold",
    "italic",
    "link",
    "|",
    "bulletedList",
    "numberedList",
    "|",
    "blockQuote",
    "insertTable",
    "|",
    "mediaEmbed",
    "imageInsert",
    "fileBrowser",
    "exportPdf",
    "exportWord",
    "exportXml",
    "|",
    "undo",
    "redo",
  ],
  sourceEditing: {
    preview: true, // Enable the preview feature
    highlightActiveLine: true, // Enable highlighting the line the cursor is on
    highlightMatches: true, // Enable highlighting matching tag pairs
  },
};

const validationSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  question: Yup.string().required("Question is required"),
  answer: Yup.string().required("Answer is required"),
  order: Yup.number()
    .typeError("Order must be a number")
    .required("Order is required"),
});

const AddEdit = ({ dispatch, match }) => {
  const [isShow, setIsShow] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [fieldValue, setFieldValue] = useState(null);
  const [fields, setfields] = useState({
    type: "",
    question: "",
    answer: "",
    order: "",
  });
  const history = useHistory();
  let editKey = match?.params?.id;

  const validateData = async (data) => {
    try {
      await validationSchema.validate(data, { abortEarly: false });
      return { isValid: true, errors: {} };
    } catch (error) {
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      return { isValid: false, errors };
    }
  };

  const handleChange = useCallback(
    (name) => (evt) => {
      setfields((prevState) => ({
        ...prevState,
        [name]: evt.target.value,
      }));
      setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    },
    []
  );

  //submit setting data
  const handleSubmit = async (evt) => {
    try {
      evt.preventDefault();
      const validation = await validateData(fields);
      if (validation.isValid) {
        let obj = {
          ...fields,
        };
        setIsShow(true);
        setIsShow(false);
        if (editKey) {
          obj = {
            ...fields,
            id: editKey,
          };
          await dispatch(updateFAQ_(obj));
        } else {
          await dispatch(addFAQ_(obj));
        }
        history.push(Path.faq);
      } else {
        setValidationErrors(validation.errors);
      }
    } catch (err) {
      setIsShow(false);
      console.log(err);
    }
  };

  async function getDataView() {
    try {
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(viewFAQ_(editKey));
      setfields(res?.body);
      setFieldValue(res?.body?.answer);
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }
  useEffect(() => {
    if (editKey) {
      getDataView();
    }
  }, []);

  return (
    <>
      <Helmet title={FAQ.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-format-list-bulleted menu-icon"></i>
          </span>
          {FAQ.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.faq}>{FAQ.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {editKey ? "Edit" : "Add"}
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{editKey ? "Edit" : "Add"} FAQ</h4>
              <form className="forms-sample" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label for="exampleInputName1">Question*</label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="exampleInputName1"
                    placeholder="Question*"
                    name="question"
                    onChange={handleChange("question")}
                    value={fields.question}
                  />
                  {validationErrors.question && (
                    <div className="text-danger err">
                      {validationErrors.question}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="type">Type*</label>
                  <div className="col-md-12">
                    <select
                      id="type"
                      className="form-select"
                      name="type"
                      onChange={handleChange("type")}
                      value={fields.type}
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      <option value="1">Player</option>
                      <option value="2">Coach</option>
                      {/* <option value="villa">Villa</option> */}
                    </select>

                    {validationErrors.type && (
                      <div className="text-danger err">
                        {validationErrors.type}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label for="exampleTextarea1">Answer*</label>
                  <CKEditor
                    editor={ClassicEditor}
                    config={editorConfiguration}
                    data={fields.answer}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setFieldValue(editor.getData());
                      setfields((prevState) => ({
                        ...prevState,
                        answer: editor.getData(),
                      }));
                      setValidationErrors({ answer: "" });
                    }}
                    className="ckeditor-control ckeditor-custom-height"
                  />
                  {validationErrors.answer && (
                    <div className="text-danger err">
                      {validationErrors.answer}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="order">Order*</label>
                  <input
                    type="number"
                    className="form-control"
                    id="order"
                    placeholder="Enter Order"
                    name="order"
                    onChange={handleChange("order")}
                    value={fields.order}
                  />

                  {validationErrors.order && (
                    <div className="text-danger err">
                      {validationErrors.order}
                    </div>
                  )}
                </div>
                <button
                  type="submit"
                  disabled={isShow ? true : false}
                  className="btn btn-gradient-primary me-2"
                >
                  {isShow ? "Loading.." : "Submit"}
                </button>
                <Link to={Path.faq}>
                  <button className="btn btn-outline-secondary btn-lg">
                    Back
                  </button>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToPros = (state) => {
  return {};
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(AddEdit);
